module.exports = {
    "Empty": `Leer`
};


//# sourceMappingURL=de-DE.main.js.map
